<!--  付款单行信息 -->
<template>
  <div>
    <vxe-toolbar v-if="canEdit">
      <template v-slot:buttons>
        <vxe-button
          @click="addBill()"
          type="primary"
          size="medium"
          class="vxe-btn-primary"
          :disabled="billDisabled"
          >新增票据</vxe-button
        >
        <vxe-button
          @click="addCert()"
          type="primary"
          size="medium"
          class="vxe-btn-primary"
          :disabled="certDisabled"
          >新增信用证</vxe-button
        >
        <vxe-button
          @click="handleDelete()"
          type="primary"
          size="medium"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >删除</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="dataTableRef"
      class="vxe-table-element"
      size="mini"
      align="center"
      :auto-resize="true"
      :data="tableData"
      height="300"
    >
      <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in columns"
        :key="index"
        :type="item.type"
        :fixed="item.fixed"
        :field="item.field"
        :title="item.title"
        :width="item.width"
        :edit-render="item.editRender"
        :visible="item.visible"
      >
        <template v-slot="{ row }">
          <span v-if="item?.field == 'otherInfoType'">{{ getInfoTypeName(row[item.field]) }}</span>
          <span v-else-if="item?.field == 'otherInfoNo'">{{ getInfoNo(row) }}</span>
          <span v-else>{{ row[item.field] }}</span>
        </template>
      </vxe-table-column>
    </vxe-grid>
    <AddBillCertDialog
      :feeInfo="feeInfo"
      ref="addDialogRef"
      @updateBill="handleBill"
      @updateCert="handleCert"
    />
  </div>
</template>

<script>
  import AddBillCertDialog from '@/pages/financeCenter/payment/paymentApply/components/addBillCertDialog';
  export default {
    components: {
      AddBillCertDialog,
    },
    props: ['canEdit', 'feeInfo'],
    computed: {
      billDisabled() {
        if (this.canEdit == false) {
          return true;
        }
        return (
          this.feeInfo?.requestCompanyCode == '' ||
          !this.feeInfo?.requestCompanyCode ||
          !this.feeInfo?.paymentMethod ||
          this.feeInfo?.paymentMethod == '' ||
          ['013', '012', '017', '10'].indexOf(this.feeInfo?.paymentMethod) == -1
        );
      },
      certDisabled() {
        return true;
        // if (this.canEdit == false) {
        //   return true;
        // }
        // return (
        //   !this.feeInfo?.paymentMethod ||
        //   this.feeInfo?.paymentMethod == '' ||
        //   ['016', '015', '10'].indexOf(this.feeInfo?.paymentMethod) == -1
        // );
      },
      columns() {
        return [
          {
            field: 'otherInfoType',
            title: '类型',
            width: 200,
          },
          {
            //公司
            field: 'otherInfoNo',
            title: '单据编号',
            width: 250,
          },
          {
            //本次抵扣金额
            field: 'amount',
            title: '金额',
            width: 200,
          },
        ];
      },
    },

    mounted() {},
    watch: {},
    data() {
      return {
        tableData: [],
      };
    },

    methods: {
      getInfoTypeName(val) {
        console.log(val);
        if (val == 'PJH') {
          return '票据';
        } else if (val == 'XYZ') {
          return '信用证';
        }
        return '';
      },
      getInfoNo(row) {
        console.log('infoNo', row);
        if (row.otherInfoType == 'PJH') {
          return row.billNo;
        } else if (row.otherInfoType == 'XYZ') {
          return row.clCode;
        }
        return '';
      },
      importTableData(data) {
        this.tableData = data;
      },
      // 获取表格数据
      exportTableData() {
        const $table = this.$refs.dataTableRef;
        return $table.getTableData().fullData;
      },
      validateByPaymentMethod() {
        let billRequired =
          this.feeInfo?.paymentMethod && ['013', '012'].indexOf(this.feeInfo?.paymentMethod) != -1
            ? true
            : false;
        // let certRequired =
        //   this.feeInfo?.paymentMethod && ['016', '015'].indexOf(this.feeInfo?.paymentMethod) != -1
        //     ? true
        //     : false;
        let certRequired = false;

        let result = this.exportTableData();

        if (billRequired || certRequired) {
          if (!result || result.length == 0) {
            //fixme
            this.$message.error('请添加票据信息');
            return false;
          }
        }
        if (billRequired) {
          let billList = result?.find((item) => item.otherInfoType == 'PJH');
          if (!billList || billList.length == 0) {
            this.$message.error('请添加票据信息');
            return false;
          }
        }
        return true;
      },
      handleDelete() {
        const selectedList = this.$refs.dataTableRef.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('interOrderType.msg.noData'),
            type: 'error',
          });
          return;
        }
        this.$refs.dataTableRef.removeSelecteds();
        this.tableData = this.exportTableData();
      },
      addBill() {
        // let tableData = [];
        // this.tableData.map((item) => {
        //   if (!item.id) {
        //     tableData.push(item);
        //   }
        // });
        this.$refs.addDialogRef.open('新增票据', this.tableData);
      },
      addCert() {
        this.$refs.addDialogRef.open('新增信用证');
      },
      async handleBill(list) {
        const $table = this.$refs.dataTableRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          let uniqueList = [];
          let repeated = false;
          if (this.tableData.length == 0) {
            uniqueList = list;
          } else {
            let curBillNoList = [];
            curBillNoList = this.tableData.map((item) => {
              return item.billNo;
            });
            list.forEach((item) => {
              if (curBillNoList.includes(item.billCode)) {
                repeated = true;
              } else {
                uniqueList.push(item);
              }
            });
          }
          if (repeated) {
            this.$message.error('添加的部分票据已重复');
          }

          let processedList = [];
          uniqueList.forEach((item) => {
            processedList.push({
              otherInfoType: 'PJH',
              billNo: item.billCode,
              amount: this.userInfo.businessGroup == '物贸' ? item.useAmount : item.billAmount,
              // useAmount: item.useAmount,
              // availableAmount: item.availableAmount,
            });
          });
          await $table.insertAt(processedList, 0);
          this.tableData = this.exportTableData();
        }
      },
      async handleCert(list) {
        const $table = this.$refs.dataTableRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        //校验重复
        // let repeatData = this.tableData.find((item) => item.clCode == val.clCode);
        // if (repeatData) {
        //   this.$message.error('添加的信用证重复');
        //   return;
        // }
        if (!errMap) {
          //fixme
          let row = { otherInfoType: 'XYZ', clCode: list.clCode };
          const { row: newRow } = await $table.insertAt(row, 0);
          await $table.validate(newRow).catch((errMap) => errMap);
          this.tableData = this.exportTableData();
        }
      },
      //清空票据信用证列表（0清空所有，1清空票据，2清空信用证）
      clear(type = 0) {
        if (type == 0) {
          this.tableData = [];
          this.$message.error('信用证票据信息已清空');
          return;
        }
        let curData = this.exportTableData();
        if (type == 1) {
          curData = curData.filter((item) => item.otherInfoType == 'XYZ');
          this.tableData = curData;
          this.$message.error('票据信息已清空');
          return;
        }
        if (type == 2) {
          curData = curData.filter((item) => item.otherInfoType == 'PJH');
          this.tableData = curData;
          this.$message.error('信用证信息已清空');
          return;
        }
      },
    },
  };
</script>
